class ProductRecommendations extends HTMLElement {
  
  #intersectionObserver = new IntersectionObserver(
    (entries, observer) => {
      if (!entries[0]?.isIntersecting) return;
      observer.disconnect();
      this.#loadRecommendations();
    },
    { rootMargin: '0px 0px 250px 0px' }
  );

  #loadRecommendations = async () => {
    const response = await fetch(this.dataset.url);
    const html = await response.text();
    const entry = this.querySelector('[data-recommendations-entry]');
    if (entry) {
      entry.innerHTML = html;
    }
  }

  async connectedCallback() {
    this.#intersectionObserver.observe(this);
  }

  disconnectedCallback() {
    this.#intersectionObserver.disconnect();
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
